<template>
	<div class="prod_settings">
		<b-overlay :show="is_load" rounded="sm">

            <div class="form-group mt-2">
                <label class="form-label" for="advanced_weight">
                    {{__t("PRODUCT_UNIQ_ID")}}
                </label>

                <div class="input-group flex-nowrap">
                    <div class="input-group-prepend">
						<span class="input-group-text">
							<i class="fal  fa-typewriter fs-xl" ></i>
						</span>
                    </div>
                    <input  id="advanced_weight" type="text" class="form-control" v-model="product.uniq_id">
                </div>
            </div>

			<div class="providers">
				<h5 class="frame-heading mt-4">{{__t("PUBLISHED_TTL_PROV")}}</h5>
				<div class="frame-wrap2">
					<div class="custom-control custom-checkbox custom-control-inli" :key="prov.id"
						 v-for="prov in providers_services">
						<input type="checkbox" v-model="prov.is_on" class="custom-control-input" :id="prov.type">
						<label class="custom-control-label" :for="prov.type">{{prov.human_name}}</label>
					</div>
				</div>
			</div>

			<div class="skeep_sync mt-5">
				<h5 class="frame-heading">{{__t("SKEEP_TTL")}}</h5>
				<div class="custom-control custom-checkbox custom-control-inline">
					<input type="checkbox" v-model="product.skeep_sync" class="custom-control-input" id="skeep_sync">
					<label class="custom-control-label" for="skeep_sync">{{__t("SKEEP_SYNC")}}</label>
				</div>
			</div>

            <!--
            <div class="skeep_sync mt-5">
                <h5 class="frame-heading">{{__t("IS_ALCO")}}</h5>
                <div class="custom-control custom-checkbox custom-control-inline">
                    <input type="checkbox" v-model="product.is_alco" class="custom-control-input" id="alco">
                    <label class="custom-control-label" for="alco">{{__t("IS_ALCO")}}</label>
                </div>
            </div>

            -->
            <div class="form-group mt-5" v-if="product.is_alco">
                <label class="form-label" for="advanced_weight">
                    {{__t("ALCO_PERCENT")}}
                </label>

                <div class="input-group flex-nowrap">
                    <div class="input-group-prepend">
						<span class="input-group-text">
							<i class="fal  fa-typewriter fs-xl" ></i>
						</span>
                    </div>
                    <input id="advanced_weight" type="number" min="0" max="100" class="form-control" v-model="product.alco_percent">
                </div>
            </div>


            <!--
            <div class="skeep_sync mt-5">
                <h5 class="frame-heading">{{__t("IS_TABACO")}}</h5>
                <div class="custom-control custom-checkbox custom-control-inline">
                    <input type="checkbox" v-model="product.is_tabaco" class="custom-control-input" id="tabco">
                    <label class="custom-control-label" for="tabco">{{__t("IS_TABACO")}}</label>
                </div>

            </div>

            <div class="skeep_sync mt-5">
                <h5 class="frame-heading">{{__t("IS_SPICY")}}</h5>
                <div class="custom-control custom-checkbox custom-control-inline">
                    <input type="checkbox" v-model="product.is_spicy" class="custom-control-input" id="spicy">
                    <label class="custom-control-label" for="spicy">{{__t("IS_SPICY")}}</label>
                </div>
            </div>
            -->

			<div class="form-group mt-4">
				<label class="form-label" for="advanced_name">
					{{__t("PRODUCT_RENAME")}}
				</label>

				<div class="input-group flex-nowrap">
					<div class="input-group-prepend">
						<span class="input-group-text">
							<i class="fal  fa-typewriter fs-xl" ></i>
						</span>
					</div>
					<input id="advanced_name" type="text" class="form-control" v-model="product.adv_name">
				</div>
			</div>


            <div class="form-group mt-2">
                <label class="form-label" for="advanced_weight">
                    {{__t("PRODUCT_WEIGHT")}}
                </label>

                <div class="input-group flex-nowrap">
                    <div class="input-group-prepend">
						<span class="input-group-text">
							<i class="fal  fa-typewriter fs-xl" ></i>
						</span>
                    </div>
                    <input id="advanced_weight" type="text" class="form-control" v-model="product.weight">
                </div>
            </div>

            <div class="form-group mt-2">
                <label class="form-label" for="advanced_weight">
                    {{__t("PRODUCT_TAX")}}
                </label>

                <div class="input-group flex-nowrap">
                    <div class="input-group-prepend">
						<span class="input-group-text">
							<i class="fal  fa-typewriter fs-xl" ></i>
						</span>
                    </div>
                    <input id="advanced_weight" type="number" min="0" max="100" class="form-control" v-model="product.tax">
                </div>
            </div>


            <div class="form-group mt-2">
                <label class="form-label" for="intro_html">
                    {{ __t('INTRO_PROD_HTML') }}

                    <button type="button" class="btn btn-xs btn-dark waves-effect waves-themed"  v-on:click="make_ai_suggest">Generate AI</button>

                </label>


                <div class="input-group flex-nowrap d-block">
                    <div class="input-group-prepend">
						<span class="input-group-text">
							<i class="fal  fa-typewriter fs-xl" ></i>
						</span>
                    </div>
                    <b-overlay :show="is_ai_work">
                        <vue-editor :editor-toolbar="editor_rules"  v-model="product.introcontent"></vue-editor>
                    </b-overlay>
                </div>
            </div>

            <div class="form-group mt-2">
                <label class="form-label" for="advanced_name">
                    {{__t('MIN_QUAL')}}
                </label>

                <div class="input-group flex-nowrap">
                    <div class="input-group-prepend">
						<span class="input-group-text">
							<i class="fal  fa-typewriter fs-xl" ></i>
						</span>
                    </div>
                    <input id="min_qual" type="number" min="0" max="100" class="form-control" v-model="product.buy_min_qual">
                </div>
            </div>

            <div class="form-group mt-2">
                <label class="form-label" for="advanced_name">
                    {{__t("PRODUCT_ORDERING")}}
                </label>

                <div class="input-group flex-nowrap">
                    <div class="input-group-prepend">
						<span class="input-group-text">
							<i class="fal  fa-typewriter fs-xl" ></i>
						</span>
                    </div>
                    <input id="ctg_ordering" type="number" class="form-control" v-model="product.ordering">
                </div>
            </div>


			<!--
			<div class="form-group mt-2">
				<label class="form-label" for="advanced_price">
					Ціна (загальна) якщо 0 - то використовується х сервісу
				</label>

				<div class="input-group flex-nowrap">
					<div class="input-group-prepend">
						<span class="input-group-text">
							<i class="fal  fa-typewriter fs-xl" ></i>
						</span>
					</div>
					<input id="advanced_price" type="text" class="form-control" v-model="product.provider_price">
				</div>
			</div>
			-->
		</b-overlay>
	</div>

</template>

<script>
import { VueEditor } from "vue2-editor";
import Info_field from "../../../../sys/info_field";
export default {
	name: "product_settings",
	components: { VueEditor,Info_field},
	props : {
		product : {
			type : Object
		},
        product_type : {
            type : String,
            default : "product",
        },
	},
	data() {
		return {
            editor_rules :[
                ["bold", "italic", "underline","link"],
                [{ align: "center" }, { align: "right" },{ align: "justify" }],
                [{ list: "ordered" }, { list: "bullet" },{ list: "check" }],
            ],
			is_load: false,
            is_ai_work : false,
		}
	},

	beforeDestroy() {
		EventBus.$off('save_product_called',this.save_product);
	},

	created() {
		EventBus.$on("save_product_called",this.save_product)
	},

	methods: {
		async save_product() {
			let prd_save = {
			    "id"                : parseInt(this.product.id),
                "introcontent"      : this.product.content,
                "organization_id"   : this.product.restaurant_id,
				"provider_price"    : this.product.provider_price,
				'adv_name'          : this.product.adv_name,
				"buy_min_qual"      : this.product.buy_min_qual,
				"restaurants"       : this.product.provider_rest_save,
				"visible_providers" : this.providers_services,
				"skeep_sync"        : this.product.skeep_sync,
                "published"         : this.product.published,
				'categories'        : this.product.current_categories,
                'extra'             : [],
                'item_type'         : this.product_type,
			};


            this.product.item_type = this.product_type;
            if(this.product.hasOwnProperty("extra")) {
                prd_save.extra = this.product.extra;
            }

			this.__l(prd_save,"info","PRODUCT -> Latest save");


			await api.put('/internal/v1/catalog/products/'+ this.product.id,{
				"product" : this.product
			}).then(({data}) => {
				if (data.status === "operation_success") {
                    EventBus.$emit('save_translation',data.data.id,'product', this.Onclose);
				}
			})
			.catch(({response}) => {
				EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
			});
		},

        make_ai_suggest() {
            if(this.is_ai_work) {
                return ;
            }
            this.ai_suggest();
        },

        async ai_suggest() {
            this.is_ai_work = true;
            await api.get('/internal/v1/ai/suggest/products/'+ this.product.id,).then(({data}) => {
                this.is_ai_work = false;
                if (data.status === "operation_success") {
                    this.product.introcontent = data.data.comment;
                }
            })
            .catch(({response}) => {
                this.is_ai_work = false;
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
            });
        },

        Onclose() {
            this.is_load = false;
            EventBus.$emit("close_product");
            EventBus.$emit("reload_products");
        },

		save_publish(prod) {
			EventBus.$emit("product_publish",prod)
		}
	},

	computed : {
		providers_services() {
			return this.product.visible_providers;
		},

	}
}
</script>

<style scoped>

</style>
